import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { Spin, Table, Tag } from 'antd';
import { Icon } from '@/components';
import { useTabNavigate } from '@/hooks/useTabNavigate';
import { DashboardStore } from '@/stores';
import { useOutletContext } from 'react-router-dom';
import EntranceComp from '@/pages/dashboard/component/entrance';
import MallTitle from '@/pages/dashboard/component/mallTitle';
import Empty from '@/pages/dashboard/component/Empty';
import CustomerServiceByAI from '@/components/CustomerServiceByAI';

import './index.less';

interface OutletProps {
  lgjIsReady: boolean;
}

interface FollowCustomer {
  customerId: string;
  customerName: string;
  mainContactsId: string | null;
  mainContactsName: string | null;
  mainContactsPhone: string | null;
  followTime: number | null;
}
const Dashboard: React.FC = () => {
  const navigate = useTabNavigate();
  const [loading] = useState<boolean>(false);
  const { lgjIsReady } = useOutletContext<OutletProps>();
  const [followCustomerList, setFollowCustomerList] = useState<FollowCustomer[]>([]);
  const [teamNoticeTodoList, setTeamNoticeTodoList] = useState<any>([]);
  // const [daifaOrderList, setDaifaOrderList] = useState<any>([]);
  // const daifaOrderListColumns = [
  //   {
  //     title: '订单编号',
  //     dataIndex: 'daifaNo',
  //     key: 'daifaNo',
  //     render: (text: string) => <a target='_blank' href={`/module/dropship/orderdispatch?no=${text}`} rel="noreferrer">{text}</a>,
  //   },
  //   {
  //     title: '客户名称',
  //     dataIndex: 'customerName',
  //     key: 'customerName',
  //   },
  //   {
  //     title: '单据状态',
  //     dataIndex: 'approveState',
  //     key: 'approveState',
  //     render: (approveState: any) => {
  //       return (<>
  //         {approveState === -30 && <span style={{color: '#777777'}}>已作废</span>}
  //         {approveState === -25 && <span style={{color:'#777777'}}>已结案</span>}
  //         {approveState === -20 && <span style={{color:'#777777'}}>已取消</span>}
  //         {approveState === -10 && <span style={{color: '#F42022'}}>已驳回</span>}
  //         {approveState === 10 && <span style={{color:'#FFAB00'}}>待审核</span>}
  //         {approveState === 20 && <span style={{color:'#2C6BFF'}}>审核中</span>}
  //         {approveState === 30 && <span style={{color:'#eb0045'}}>已审核</span>}
  //       </>)
  //     },
  //   },
  //   {
  //     title: '发货状态',
  //     dataIndex: 'deliveryState',
  //     key: 'deliveryState',
  //     render: (deliveryState: any) => {
  //       return (<>
  //         {deliveryState === -10 && <span style={{color:'#777777'}}>未发货</span>}
  //         {deliveryState === 10 && <span style={{color:'#FFAB00'}}>部分发货</span>}
  //         {deliveryState === 20 && <span style={{color:'#eb0045'}}>全部发货</span>}
  //       </>)
  //     },
  //   },
  //   {
  //     title: '订单类型',
  //     dataIndex: 'orderType',
  //     key: 'orderType',
  //     render: (orderType: any) => {
  //       return (
  //         <>
  //           {orderType === 1 && <div>集采批发</div>}
  //           {orderType === 2 && <div>一件代发</div>}
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     title: '标签',
  //     dataIndex: 'tags',
  //     key: 'tags',
  //     render: (tags: any) => {
  //       if (tags.length === 0) {
  //         return <span>-</span>;
  //       }
  //       const tagList = tags?.split(',');
  //       return tagList?.map((item: any) => {
  //         return <Tag key={item} color='green'>{item}</Tag>;
  //       });
  //     },
  //   },
  //   {
  //     title: '商品总数量',
  //     dataIndex: 'goodsNum',
  //     key: 'goodsNum',
  //   },
  //   {
  //     title: '运费总金额',
  //     dataIndex: 'totalFreight',
  //     key: 'totalFreight',
  //   },
  //   {
  //     title: '商品总金额',
  //     dataIndex: 'totalGoodsPrice',
  //     key: 'totalGoodsPrice',
  //   },
  //   {
  //     title: '订单总金额',
  //     dataIndex: 'totalPrice',
  //     key: 'totalPrice',
  //   },
  // ]

  const [quotationList, setQuotationList] = useState<any>([]);
  const quotationListColumns = [
    {
      title: '报价单编号',
      dataIndex: 'quotationNo',
      key: 'quotationNo',
      render: (text: string, item: any) => (
        <a target="_blank" href={`/module/sales/quote/create?id=${item.id}`} rel="noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: '报价单标题',
      dataIndex: 'quotationTitle',
    },
    {
      title: '单据状态',
      dataIndex: 'approveSateDesc',
    },
    {
      title: '报价状态',
      dataIndex: 'quotationStateDesc',
      render: (approveSateDesc: any) => {
        return <span>{approveSateDesc || '-'}</span>;
      },
    },
    {
      title: '客户名称',
      dataIndex: 'customerName',
    },
    {
      title: '商品总数',
      dataIndex: 'goodsNum',
    },
    {
      title: '报价总额',
      dataIndex: 'price',
      render: (price: any) => {
        return <span>{price / 100}</span>;
      },
    },
    {
      title: '报价主体',
      dataIndex: 'companyName',
    },
    {
      title: '报价人',
      dataIndex: 'creatorName',
    },
  ];

  const [programList, setProgramList] = useState<any>([]);
  const programListColumns = [
    {
      title: '方案编号',
      dataIndex: 'id',
      key: 'id',
      render: (text: string) => (
        <a target="_blank" href={`/share/pptnew/show/${text}`} rel="noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: '方案名称',
      dataIndex: 'name',
      key: 'name',
    },
    // {
    //   title: '客户名称',
    //   dataIndex: 'customerName',
    //   key: 'customerName',
    //   render: (customerName: any) => customerName || '无',
    // },
    {
      title: '商品数量',
      dataIndex: 'goodsCount',
      key: 'goodsCount',
    },
    // {
    //   title: '发布状态',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: (status: number) => status>1?<span style={{color:'#eb0045'}}>已发布</span>:<span>未发布</span>, // •
    // },
    // {
    //   title: '是否主推',
    //   dataIndex: 'isMainPromotion',
    //   key: 'isMainPromotion',
    //   render: (isMainPromotion: boolean) => isMainPromotion?'是':'否',
    // },
    {
      title: '创建人',
      dataIndex: 'userName',
      key: 'userName',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
  ];
  const [isPlan, setIsPlan] = useState<boolean>(true);
  const initData = async () => {
    // 待办列表
    DashboardStore.getTeamNoticeTodoList({}).then((res: any) => {
      // console.log('res=======>', res);
      if (res.data) {
        // console.log('res.data=======>', res.data);
        if (res.data.list) {
          setTeamNoticeTodoList(res.data.list);
        }
      }
    });
    // 关注客户
    DashboardStore.userFollowCustomerList({ limit: 5 }).then((followCustomerRes: any) => {
      // console.log('followCustomerRes=======>', followCustomerRes);
      if (followCustomerRes.data) {
        setFollowCustomerList(followCustomerRes.data);
      }
    });

    // 方案列表
    DashboardStore.getProgramList({
      goodsIdList: [],
      ownerType: 0,
      pageNo: 1,
      pageSize: 20,
      tagIdList: [],
      type: 6,
    }).then((res: any) => {
      // console.log('方案列表=======>', res);
      if (res.data) {
        // console.log('res.data=======>', res.data);
        if (res.data.list) {
          setProgramList(res.data.list);
        }
      }
    });

    // 获取报价单列表
    DashboardStore.getQuotationList({
      state: 10,
      quotationPersonIdIsSelf: true,
    }).then((res: any) => {
      // console.log('res=======>', res);
      if (res.data) {
        // console.log('res.data=======>', res.data);
        if (res.data.list) {
          setQuotationList(res.data.list);
        }
      }
    });

    // 待发货订单
    // DashboardStore.getDaifaOrderList({}).then((res: any) => {
    //   console.log('订单列表=======>', res);
    //   if (res.data) {
    //     setDaifaOrderList(res.data);
    //     // console.log('res.data=======>', res.data);
    //   }
    // });
  };

  useEffect(() => {
    if (lgjIsReady) {
      initData();
    }
  }, [lgjIsReady]);

  const handleClickToLink = (href: string) => {
    navigate(href);
  };
  const handleTapClick = (redirect: string) => {
    window.open(redirect, '_self');
  };
  const handleToHelp = (href: string) => {
    window.open(href, '_blank');
  };
  const handleTeamNoticeClick = (item: any) => {
    if (item.state < 2) {
      DashboardStore.teamNoticeSetState({
        ids: [item.team_notice_id],
        state: '2',
      }).then(() => {});
    }
    setTimeout(() => {
      handleTapClick(`/webview/lgj${item.href}`);
    }, 50);
  };

  return (
    <Spin spinning={loading}>
      <div className="mall-container">
        <div className={cn('mall-left', 'mall-margin-bottom')}>
          {/* 快捷入口 */}
          <div className={cn('mall-card-box', 'mall-margin-bottom')}>
            <div className="mall-title">
              <div className="mall-title-left">
                <span className="title-icon" />
                <span>快捷入口</span>
              </div>
            </div>
            <EntranceComp />
          </div>

          <div className={cn('mall-banner', 'mall-margin-bottom')}>
            <img src="https://oss.elebuys.com/202506181515080005105632.png" alt="" />
          </div>

          {/* 业务数据 */}
          <div className={cn('mall-card-box', 'mall-margin-bottom')}>
            <MallTitle
              title="业务数据"
              count={0}
              cb={() => {
                if (isPlan) {
                  handleClickToLink('/module/program/cai/0');
                } else {
                  handleClickToLink('/module/sales/quote');
                }
              }}
            />
            <div className={cn('mall-table-tabs')}>
              <div
                onClick={() => {
                  setIsPlan(true);
                }}
                className={cn('table-plan', isPlan ? 'selected' : '')}
              >
                方案
              </div>
              <div
                onClick={() => {
                  setIsPlan(false);
                }}
                className={cn('table-order', isPlan ? '' : 'selected')}
              >
                报价单
              </div>
            </div>
            <div className="mall-table-box">
              {isPlan && programList?.length > 0 && (
                <Table
                  rowKey={'id'}
                  size={'small'}
                  dataSource={programList}
                  columns={programListColumns}
                  pagination={false}
                />
              )}
              {isPlan && programList?.length === 0 && <Empty />}

              {!isPlan && quotationList?.length > 0 && (
                <Table
                  scroll={{ x: 1060 }}
                  rowKey={'id'}
                  size={'small'}
                  dataSource={quotationList}
                  columns={quotationListColumns}
                  pagination={false}
                />
              )}
              {!isPlan && quotationList?.length === 0 && <Empty />}
            </div>
          </div>
        </div>
        <div className="mall-right">
          <div className={cn('mall-card-box', 'mall-margin-bottom')}>
            <MallTitle
              title="待办事项"
              count={0}
              cb={() => {
                handleClickToLink('/webview/lgj/mall/order/list');
              }}
            />
            <div className="mall-card-box">
              {teamNoticeTodoList.length > 0 ? (
                teamNoticeTodoList.map((item: any) => {
                  return (
                    <div
                      className="mall-card-todo-li"
                      onClick={() => {
                        handleTeamNoticeClick(item);
                      }}
                      key={item.team_notice_id}
                    >
                      <div className="list-info">
                        <span className={cn('info-tag', item.state === '2' ? 'has-read' : '')}>
                          {item.state === '2' ? '已读' : '未读'}
                        </span>
                        <span className={cn('info-text', item.state === '2' ? 'has-read' : '')}>
                          {item.content}
                        </span>
                      </div>
                      <div className="list-time">{item.create_time}</div>
                    </div>
                  );
                })
              ) : (
                <div>
                  <Empty />
                </div>
              )}
              {/* <div className="mall-card-todo-li">
                <div className="list-info">
                  <span className={cn('info-tag', 'has-read')}>未读</span>
                  <span className={cn('info-text', 'has-read')} dangerouslySetInnerHTML={{ __html: '' }} />
                </div>
                <div className="list-time">2025/01/03 15:00:03</div>
              </div> */}
            </div>
          </div>
          <div className={cn('mall-card-box', 'mall-margin-bottom')} style={{ minHeight: 436 }}>
            <MallTitle
              title="关注客户"
              count={0}
              cb={() => {
                handleClickToLink('/module/customer/list');
              }}
            />
            <div className="mall-card-box">
              {followCustomerList.length > 0 ? (
                followCustomerList.map((item: FollowCustomer) => {
                  return (
                    <div
                      className="mall-card-customer-li"
                      key={item.customerId}
                      onClick={() => {
                        handleClickToLink(`/module/customer/detail/${item.customerId}`);
                      }}
                    >
                      <div className="customer-title">{item.customerName}</div>
                      <div className="customer-info">
                        <div>
                          联系人<span>{item.mainContactsName ? item.mainContactsName : '--'}</span>
                        </div>
                        <div>
                          联系电话
                          <span>{item.mainContactsPhone ? item.mainContactsPhone : '--'}</span>
                        </div>
                        <div>
                          最近跟进<span>{item.followTime ? item.followTime : '--'}</span>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div>
                  <Empty />
                </div>
              )}
              {/* <div className='mall-card-customer-li'>
                <div className='customer-title'>杭州阿里巴巴数字技术股份有限公司</div>
                <div className='customer-info'>
                  <div>联系人<span>李云云</span></div>
                  <div>联系电话<span>18900230034</span></div>
                  <div>最近跟进<span>2025/01/03 13:00:00</span></div>
                </div>
              </div> */}
            </div>
          </div>

          {/* <div className={cn('mall-card-box', 'mall-margin-bottom')}>
            <MallTitle title="学习中心" count={-1} cb={() => {}} />
            <div className="mall-card-box">
              <div
                className="mall-card-study-li"
                onClick={() =>
                  handleToHelp(
                    'https://oss.elebuys.com/resource/goods/materials/202412122011250006881965.pdf',
                  )
                }
              >
                <Icon type="icon-pdf" style={{ fontSize: 24 }} />
                <span className="study-title">查看操作文档</span>
                <Icon className="study-icon-xiazai" type="icon-xiazai" />
              </div>

              <div
                className="mall-card-study-li"
                onClick={() =>
                  handleToHelp(
                    'https://fx-pangu.oss-cn-hangzhou.aliyuncs.com/%E5%A4%A9%E7%8C%AB%E8%B6%85%E5%B8%82%E4%BC%81%E4%B8%9A%E8%B4%AD%E6%96%B0%E5%8A%9F%E8%83%BD.pdf',
                  )
                }
              >
                <Icon type="icon-pdf" style={{ fontSize: 24 }} />
                <span className="study-title">天猫超市企业购新功能</span>
                <Icon className="study-icon-xiazai" type="icon-xiazai" />
              </div>
            </div>
          </div> */}

        </div>
      </div>
      {/* AI客服 */}
      <CustomerServiceByAI />
    </Spin>
  );
};

export default Dashboard;
